(function() {
  var ceri, getIcon, getIcons;

  getIcons = function() {};

  var sets = {ma: {a: {},i: {person: {d: "M256 299c57 0 171 28 171 85v43H85v-43c0-57 114-85 171-85zm0-43c-47 0-85-38-85-85s38-86 85-86 85 39 85 86-38 85-85 85z",w: 512,h: 512},vpn_key: {d: "M149 299c23 0 43-20 43-43s-20-43-43-43-42 20-42 43 19 43 42 43zm121-86h221v86h-43v85h-85v-85h-93c-17 50-65 85-121 85-71 0-128-57-128-128s57-128 128-128c56 0 104 35 121 85z",w: 512,h: 512}}}}

function getIcon(coll, name) {
  set = sets[coll]
  if (process.env.NODE_ENV !== 'production' && (typeof set === "undefined" || set === null)){
    console.warn("ceri-icons - icon collection "+coll+" not found, is your webpack set up correctly?")
  }
  if (set.a[name] != null) {
    name = set.a[name]
  }
  var icon = set.i[name]
  if (process.env.NODE_ENV !== 'production' && (typeof icon === "undefined" || icon === null)) {
    console.warn("cerivue-icons - icon "+coll+"-"+name+" not found, is your webpack set up correctly?")
  }
  return icon
}

  if (process.env.NODE_ENV !== 'production' && (typeof getIcon === "undefined" || getIcon === null)) {
    console.error("icon-loader wasn't called - please see ceri-icons documentation on how to setup webpack");
    getIcon = function(name1, name2) {
      return console.error("vue-icons isn't setup properly - failed to get " + name1 + "-" + name2);
    };
  }

  ceri = require("ceri/lib/wrapper");

  module.exports = ceri({
    isCeriIcon: true,
    mixins: [require("ceri/lib/structure"), require("ceri/lib/svg"), require("ceri/lib/style"), require("ceri/lib/props"), require("ceri/lib/util"), require("ceri/lib/#show")],
    structure: function(){return [this.el("svg",{"version":{"":"1.1"},"role":{":":function(){return this.label?'img':'presentation';}},"show":{"#":{"val":"icon","mods":{"delay":true}}},"aria-label":{":":"label"},"width":{"":"0",":":"outerWidth"},"height":{"":"0",":":"outerHeight"},"view-box":{":":{"val":"box","mods":{"camel":true}}}},[this.el("path",{"d":{":":"icon.d"},"transform":{":":"flipped"},"fill":{"":"currentColor"}},[])]),"default"]}











,
    props: {
      name: String,
      size: Number,
      scale: {
        type: Number,
        "default": 1
      },
      offsetX: {
        type: Number,
        "default": 0
      },
      offsetY: {
        type: Number,
        "default": 0
      },
      flipH: Boolean,
      flipV: Boolean,
      label: String,
      hcenter: Boolean
    },
    initStyle: {
      display: "inline-block"
    },
    computedStyle: function() {
      var position;
      if (this.isStack) {
        position = "relative";
      } else if (this.stackParent) {
        position = "absolute";
      } else {
        position = null;
      }
      return {
        height: this.outerHeight + "px",
        position: position,
        left: this.stackParent ? 0 : null
      };
    },
    data: function() {
      return {
        isStack: false,
        stackParent: false
      };
    },
    connectedCallback: function() {
      var child, j, len, ref, results;
      this._stackChildren = [];
      ref = this.children;
      results = [];
      for (j = 0, len = ref.length; j < len; j++) {
        child = ref[j];
        if (child.isCeriIcon) {
          child.stackParent = this;
          this._stackChildren.push(child);
          results.push(this.isStack = true);
        } else {
          results.push(void 0);
        }
      }
      return results;
    },
    computed: {
      processedName: function() {
        var set, tmp;
        if (!this.name) {
          return null;
        }
        tmp = this.name.split("-");
        set = tmp.shift();
        return [set, tmp.join("-")];
      },
      icon: function() {
        var i;
        if (!this.processedName) {
          return null;
        }
        i = getIcon(this.processedName[0], this.util.camelize(this.processedName[1]));
        return i;
      },
      box: function() {
        var h, hOffset, s, w, wOffset;
        if (!(this.heightRatio && this.icon)) {
          return null;
        }
        w = this.icon.w;
        h = this.icon.h;
        wOffset = -w * ((this.widthRatio - 1) / 2 + this.offsetX / 100);
        hOffset = -h * ((this.heightRatio - 1) / 2 - this.offsetY / 100);
        if (this.flipV) {
          s = "-" + (w + wOffset) + " ";
        } else {
          s = wOffset + " ";
        }
        if (this.flipH) {
          s += "-" + (h + hOffset) + " ";
        } else {
          s += hOffset + " ";
        }
        return s + ((w * this.widthRatio) + " " + (h * this.heightRatio));
      },
      aspect: function() {
        if (!this.icon) {
          return null;
        }
        return this.icon.w / this.icon.h;
      },
      innerWidth: function() {
        return this.aspect * this.innerHeight;
      },
      outerWidth: {
        master: true,
        get: function() {
          var child, cw, j, len, ref, w;
          if (this.stackParent) {
            return this.stackParent.outerWidth;
          }
          w = this.innerWidth;
          if (this.isStack) {
            ref = this._stackChildren;
            for (j = 0, len = ref.length; j < len; j++) {
              child = ref[j];
              cw = child.innerWidth * (1 + Math.abs(child.offsetX) / 50);
              w = Math.max(cw, w);
            }
          }
          return w;
        }
      },
      widthRatio: function() {
        return this.outerWidth / this.innerWidth;
      },
      innerHeight: function() {
        if (this.size != null) {
          return this.size * this.scale;
        } else {
          return parseFloat(window.getComputedStyle(this).getPropertyValue("font-size")) * this.scale;
        }
      },
      outerHeight: {
        master: true,
        get: function() {
          var ch, child, h, j, len, ref;
          if (this.stackParent) {
            return this.stackParent.outerHeight;
          }
          if (this.hcenter) {
            return this.parentElement.clientHeight;
          }
          h = this.innerHeight;
          if (this.isStack) {
            ref = this._stackChildren;
            for (j = 0, len = ref.length; j < len; j++) {
              child = ref[j];
              ch = child.innerHeight * (1 + Math.abs(child.offsetY) / 50);
              h = Math.max(ch, h);
            }
          }
          return h;
        }
      },
      heightRatio: function() {
        return this.outerHeight / this.innerHeight;
      },
      flipped: function() {
        if (!(this.flipH || this.flipV)) {
          return null;
        }
        return "scale(" + (-this.flipV * 2 + 1) + "," + (-this.flipH * 2 + 1) + ")";
      }
    }
  });

}).call(this);



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri-icon/icon.js
// module id = 42
// module chunks = 1